import axios from "axios";
import Notification from "../notification";
import MessageBoxService from "../message-box";
const messageBoxService = new MessageBoxService();

const HTTPService = axios.create({
  baseURL: "/api",
  headers: { "X-Requested-With": "XMLHttpRequest" }
});

// request interceptor
HTTPService.interceptors.request.use(
  config => {
    // do something before request is sent
    return config;
  },
  error => {
    // do something with request error
    console.log(error); // for debug
    return Promise.reject(error);
  }
);

// response interceptor
HTTPService.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data;
    const { config } = response;
    const { showNotification = false } = config;
    if (showNotification) {
      const { hasError = false, message = "", result = {} } = res;
      if (hasError) {
        Notification.error({
          message,
          duration: 4000
        });
      } else {
        Notification.success({
          message,
          duration: 4000
        });
      }
    }
    return res;
  },
  error => {
    if (error.response.status === 401) {
      messageBoxService.showAlert("Session Expired", {
        showClose: false,
        confirmButtonText: "Re-Login",
        customClass: "relogin-popup",
        callback: () => {
          window.location.href = "/staff/logout"
        }
      });
    }
    console.log("err" + error); // for debug
    return Promise.reject(error);
  }
);

export default HTTPService;
